import * as React from 'react';
/**
 *
 * Original name: trending
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=54623%3A43
 *
 */
export const TrendingLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m18.733 9.545-.078-3.967-3.967-.078L14.66 7l1.481.03-3.668 3.685L10 8.491l-5.502 4.952 1.004 1.114L10 10.51l2.528 2.276 4.674-4.697.002.002.03 1.484 1.499-.03ZM19.5 17.5h-15V19h15v-1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
